import React, { useState, useEffect, useCallback } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import Star from "../../assets/images/icons/star.svg";
import Girl from "../../assets/images/girl.jpg";
import FilterTrigger, { isDateRangeFilterActive } from "../../commons/FilterTrigger/FilterTrigger";
import DateRangeFilterMenu from "../../commons/DateRangeFilterMenu/DateRangeFilterMenu";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";

function ReviewAndRatingManagement() {
  // const totalRatings = 886;
  // const averageRating = 4.8;

  // const ratings = [
  //   { stars: 5, count: 7000 },
  //   { stars: 4, count: 200 },
  //   { stars: 3, count: 300 },
  //   { stars: 2, count: 20 },
  //   { stars: 1, count: 10 },
  // ];

  // const maxCount = Math.max(...ratings.map((r) => r.count));
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeTab, setActiveTab] = useState("dish"); // 'dish' or 'restaurant'
  const [reviewData, setReviewData] = useState([]);
  const [overallRating, setOverallRating] = useState({
    avgRating: 0,
    totalRestaurants: 0,
    ratingBreakdown: {}
  });
  const [loading, setLoading] = useState(false);
  const [page] = useState(1);
  const [limit] = useState(10);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const toggleDropdown = (id) => {
    setActiveDropdown(activeDropdown === id ? null : id);
  };

  // Helper function to render stars based on rating
  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(i < fullStars ? "★" : "☆");
    }
    return stars.join(" ");
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  const handleResetDateFilter = () => {
    setStartDate("");
    setEndDate("");
    setActiveDropdown(null);
  };

  // Fetch reviews based on active tab
  const fetchReviews = useCallback(async () => {
    setLoading(true);
    try {
      const endpoint = activeTab === "dish" ? endpoints.dishReviewList : endpoints.restaurantReviewList;
      console.log("endpoint",endpoint);
      
      const query = new URLSearchParams({
        page,
        limit,
        startDate,
        endDate
      }).toString();

      const response = await handleApiCall("get", `${endpoint}?${query}`);
      if (response?.data?.code === 200) {        
        setReviewData(response?.data?.data.review || []);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
    } finally {
      setLoading(false);
    }
  }, [activeTab, page, limit, startDate, endDate]);

  useEffect(() => {
    fetchReviews();
  }, [fetchReviews]);

  console.log("activeTab", activeTab);
  console.log("reviewData",reviewData.length);

  // Fetch reviews based on active tab
  const fetchOverAllRating = useCallback(async () => {
    setLoading(true);
    try {
      const endpoint = activeTab === "dish" ? endpoints.dishOverAllRating : endpoints.restaurantOverAllRating;
      console.log("endpoint",endpoint);

      const response = await handleApiCall("get", `${endpoint}`);
      
      if (response?.data?.code === 200) {                
        setOverallRating(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
    } finally {
      setLoading(false);
    }
  }, [activeTab, page, limit]);

  useEffect(() => {
    fetchOverAllRating();
  }, [fetchOverAllRating]);
  
  const ratings = overallRating?.ratingBreakdown
  ? Object.keys(overallRating.ratingBreakdown)
      .sort((a, b) => b - a)
      .map((key) => ({
        stars: Number(key),
        count: overallRating.ratingBreakdown[key]?.count || 0,
      }))
  : [];

const maxCount =
  ratings.length > 0 ? Math.max(...ratings.map((r) => r.count)) : 1;

const totalRatings = ratings.reduce(
  (sum, item) => sum + item.count,
  0
);

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Review & Rating Management</h3>
              <div className="dropdown text-end ml-auto w-auto mr-1">
                <FilterTrigger
                  variant="icon"
                  bordered={false}
                  active={isDateRangeFilterActive(startDate, endDate)}
                  onClick={() => toggleDropdown(1)}
                />
                <div className={`dropdown-menu dropdown-menu-end rounded-14 border-0 shadow-lg p-4 ${activeDropdown === 1 ? "show" : ""}`} style={{ top: "0px", right: "35px" }}>
                  <DateRangeFilterMenu
                    isOpen={activeDropdown === 1}
                    appliedFrom={startDate || null}
                    appliedTo={endDate || null}
                    onApply={(start, end) => {
                      setStartDate(start);
                      setEndDate(end);
                      setActiveDropdown(null);
                    }}
                    onReset={handleResetDateFilter}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="border px-3 py-2 mt-3 rounded-14 text-white card">
                  <div className="row align-items-center flex-fill">
                    <div className="col-md-3">
                      <div className="display-4 d-flex align-items-center">
                        {/* {overallRating.avgRating}{0} */}
                        {/* {overallRating?.avgRating?.toFixed(1) || 0} */}
                        {Number(overallRating?.avgRating || 0).toFixed(1)}
                        <span className="text-warning">
                          <img src={Star} alt="Star" className="ml-1" style={{ top: "-4px", position: "relative" }} />
                        </span>
                      </div>
                      {/* <div className="text-light">{totalRatings} Rating</div> */}
                      <div className="text-light">
                        {/* {overallRating?.totalDish || 0} Ratings */}
                        {totalRatings} Ratings
                      </div>
                    </div>
                    <div className="col-md-9 border-left">
                      {ratings.map((rating) => {
                        const barWidth = (rating.count / maxCount) * 100;
                        return (
                          <div key={rating.stars} className="d-flex align-items-center my-2">
                            <div style={{ width: "30px" }} className="d-flex align-items-center">
                              {rating.stars} <img src={Star} alt="Star" className="ml-2" style={{ height: "10px", top: "-1px", position: "relative" }} />
                            </div>
                            <div className="progress flex-grow-1 mx-2" style={{ height: "6px", borderRadius: "20px" }}>
                              <div
                                className="progress-bar bg-white"
                                role="progressbar"
                                style={{ width: `${barWidth}%` }}
                                aria-valuenow={rating.count}
                                aria-valuemin="0"
                                aria-valuemax={maxCount}
                              ></div>
                            </div>
                            <div style={{ width: "50px" }}>{rating.count}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 d-flex align-items-start">
                <div className="border px-3 py-2 mt-3 rounded-14 card flex-row">
                  <div class="btn-group rounded-0">
                    <button type="button" class={`btn btn-outline ${activeTab === "dish" ? "active" : ""}`} onClick={() => setActiveTab("dish")}>
                      Dish
                    </button>
                    <button type="button" class={`btn btn-outline ${activeTab === "restaurant" ? "active" : ""}`} onClick={() => setActiveTab("restaurant")}>
                      Restaurant
                    </button>
                    {/* <button type="button" class="btn btn-outline active">Driver</button> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="review_wrapper text-white">
              {loading ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : reviewData.length === 0 ? (
                <div className="text-center py-4">No reviews found</div>
              ) : activeTab === "restaurant" ? (
                // Restaurant Reviews
                reviewData.map((review, index) => (
                  <div key={index} className="p-3 border-1 rounded-14 mt-4 card">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="d-flex align-items-center">
                        {/* <img src={Girl} alt="User avatar" className="rounded-circle me-2" width="40" height="40" /> */}
                        <img className="rounded-circle me-2"
                            src={review.customer?.image}
                            alt="Dish" 
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />
                        <div className="d-flex flex-column">
                          <div className="fw-bold">{review.customer?.full_name || "N/A"}
                            {/* | Restaurant: {review.restaurant_id?.restaurant_name || "N/A"} |
                            Order Id : {review.order_number|| "N/A"}  */}

                          </div>
                          <div className="text-warning small">{renderStars(parseInt(review.customer_rating))}</div>
                        </div>
                      </div>
                      <div className="text-light small fw-semibold">
                        Restaurant: {review.restaurant?.restaurant_name || "N/A"}  |
                        Order Id : {review.order_number|| "N/A"} |
                        {formatDate(review.createdAt)}
                      </div>
                      {/* <div className="mt-2" style={{ fontSize: "14px", lineHeight: "1.5" }} >
                        Restaurant: {review.restaurant_id?.restaurant_name || "N/A"}  |
                        Order Id : {review.order_number|| "N/A"} |
                          {formatDate(review.createdAt)}
                      </div> */}
                    </div>
                    <div className="mt-2" style={{ fontSize: "14px", lineHeight: "1.5" }}>
                      {review.customer_review || "No review text"}
                    </div>
                  </div>
                ))
              ) : (
                // Dish Reviews
                reviewData.map((dish, index) => (
                  <div key={index} className="p-3 border-1 rounded-14 mt-4 card">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="d-flex align-items-center">
                        {/* <img src={Girl} alt="Dish" className="rounded-circle me-2" width="40" height="40" /> */}
                          <img className="rounded-circle me-2"
                            src={dish?.dish_id?.image}
                            alt="Dish" 
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />

                        <div className="d-flex flex-column">
                          <div className="fw-bold">{dish?.dish_id?.dish_name || "N/A"}</div>
                          <div className="text-warning small">{renderStars(parseInt(dish.customer_rating))}</div>
                        </div>
                      </div>
                      {/* <div className="text-light small fw-semibold">{dish.restaurant_id?.restaurant_name || "N/A"}</div> */}
                      <div className="text-light small fw-semibold">
                        Order Id: {dish.order_number || "N/A"} | 
                        {formatDate(dish.createdAt) || "N/A"}
                        </div>
                    </div>
                    <div className="mt-2" style={{ fontSize: "14px", lineHeight: "1.5" }}>
                      Restaurant: {dish.restaurant_id?.restaurant_name || "N/A"} | 
                      Customer: {dish.customer_id?.full_name || "N/A"} | 
                      {/* Order Id: {dish.order_number || "N/A"} |  */}
                      {/* Average Rating: {dish.dish_id.dish_average_rating || "N/A"}  */}
                      {/* | Total Ratings:{" "}
                      {dish.dish_rating_count || 0} */}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReviewAndRatingManagement;
